import React from 'react';

import buildDraggableArea from './DraggableAreaBuilder';

const DraggableArea = buildDraggableArea();
export { DraggableArea };
